//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../Annotations/Annotations.StyleBuilder.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../no/ugmath.js";
import "../no/Annotations.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CreatedHoleManufacturingNote",1,"NXObject",0],[0,"DefineByViewOrHolesEnum",1,0],[0,"HoleIndexColor",1,0],[0,"HoleIndexSize",1,0],[0,"HoleIndexTypeEnum",1,0],[0,"HoleManufacturingNoteColor",1,0],[1,"HoleManufacturingNoteOrigin",0,"Annotations.OriginBuilder",0],[0,"HoleManufacturingNoteSize",1,0],[1,"HoleManufacturingNoteStyle",0,"Annotations.StyleBuilder",0],[1,"SelectHoles",0,"SelectNXObjectList",0],[1,"SelectView",0,"SelectNXObject",0],[0,"UseDifferentSubIndexForSameDiameterHoles",1,0],[0,"WizardType",1,0]],[[["viewTag","holeTypeIndex","faceTag","holeDiameter","holePos","holetype","reverseFlag"],"CreateHoleIndexLabel",{R_:{indexLabelTag:"NXObject"}},7,0],[["viewTag","holeManufacturingNoteVector","point"],"CreateHoleManufacturingNoteAsNote",{R_:{noteTag:"NXObject"}},3,0],[["viewTag","vseqNumber","isDrawing","inObject"],"CycleObjectsInView",{R_:{outPutObject:"NXObject"}},4,0],[[],"ModifyStyle",{},0,0]],[]];
SPLM.Tooling.HoleManufacturingNoteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.HoleManufacturingNoteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.HoleManufacturingNoteBuilder.DefineByViewOrHoles = Object.freeze({
    "View" : "View", "Holes" : "Holes"});

SPLM.Tooling.HoleManufacturingNoteBuilder.HoleIndexType = Object.freeze({
    "UserDefinedAndNumber" : "UserDefinedAndNumber", "Alphabetic" : "Alphabetic", "Numeric" : "Numeric"});

export default SPLM;